import { z } from 'zod';
import { emailSchema } from './email.schema';
import { passwordSchema } from './password.schema';

export const signUpSchema = z
  .object({
    email: emailSchema,
    code: z
      .string({ message: 'Pflichtfeld' })
      .min(6, { message: 'Der Code muss 6 Zeichen lang sein.' })
      .max(6, { message: 'Der Code muss 6 Zeichen lang sein.' }),
    password: passwordSchema,
    confirmPassword: passwordSchema,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwörter stimmen nicht überein.',
    path: ['confirmPassword'],
  });
